import React, { useMemo, useState } from "react";

const Contact = () => {
  const [form, setForm] = useState({ name: "", email: "", message: "" });

  const references = useMemo(
    () => [
      {
        name: "Liceth Yaneth Rozo Quintana",
        role: "Desarrolladora Backend Senior",
        company: "Finkargo Colombia SAS",
        email: "liyarozoquin12@gmail.com",
      },
      {
        name: "Jhon Andres Parra Rodriguez",
        role: "Analista especializado 1",
        company: "Banco Av Villas",
        email: "jhonandres0322@gmail.com",
      },
      {
        name: "Yonathan Carvajal",
        role: "Desarrollador Backend Senior",
        company: "Certicamara",
        email: "yonathan.carvajal@certicamara.com",
      },
      {
        name: "John Edward Osorio Carrero",
        role: "Director de Ingeniería",
        company: "Certicamara",
        email: "john.osorio@certicamara.com",
      },
    ],
    []
  );

  const onSubmit = (e) => {
    e.preventDefault();

    const subject = "Contacto desde portafolio";
    const body = `Nombre: ${form.name}\nEmail: ${form.email}\n\nMensaje:\n${form.message}`;

    window.location.href = `mailto:marleyrozo@gmail.com?subject=${encodeURIComponent(
      subject
    )}&body=${encodeURIComponent(body)}`;
  };

  const inputClasses =
    "w-full mt-1 rounded-xl border border-[#3f5232]/15 bg-white/80 px-3 py-2 text-slate-800 placeholder-slate-400 shadow-sm " +
    "focus:outline-none focus:ring-2 focus:ring-[#3f5232]/25 focus:border-[#3f5232]/25 transition";

  return (
    <section id="contact" aria-label="Contacto" className="relative py-20">
      <div className="absolute inset-0 bg-gradient-to-br from-[#f6f7f4] via-white to-[#eef2ee]" />

      <div className="relative max-w-6xl mx-auto px-4">
        <div className="mb-10">
          <h2 className="font-poppins text-3xl font-semibold tracking-tight text-slate-900">
            Contacto
          </h2>
          <p className="mt-3 max-w-2xl text-slate-600">
            Si deseas que trabajemos juntos, cuéntame brevemente tu idea o
            necesidad. Respondo lo antes posible.
          </p>
        </div>

        <div className="grid gap-6 md:grid-cols-2">
          {/* FORMULARIO */}
          <form
            onSubmit={onSubmit}
            className="rounded-2xl border border-[#3f5232]/15 bg-white/70 backdrop-blur p-6 shadow-sm"
          >
            <div className="flex items-center justify-between gap-3">
              <h3 className="text-lg font-semibold text-slate-900">
                Envíame un mensaje
              </h3>
              <span className="text-xs font-medium text-[#3f5232] bg-[#f4f6f1] border border-[#3f5232]/15 px-3 py-1 rounded-full">
                Email directo
              </span>
            </div>

            <div className="mt-5 grid gap-4">
              <label className="block text-sm text-slate-700">
                <span className="font-medium">Nombre</span>
                <input
                  required
                  value={form.name}
                  onChange={(e) => setForm({ ...form, name: e.target.value })}
                  className={inputClasses}
                  placeholder="Tu nombre"
                />
              </label>

              <label className="block text-sm text-slate-700">
                <span className="font-medium">Email</span>
                <input
                  required
                  type="email"
                  value={form.email}
                  onChange={(e) => setForm({ ...form, email: e.target.value })}
                  className={inputClasses}
                  placeholder="tu@email.com"
                />
              </label>

              <label className="block text-sm text-slate-700">
                <span className="font-medium">Mensaje</span>
                <textarea
                  required
                  rows={5}
                  value={form.message}
                  onChange={(e) =>
                    setForm({ ...form, message: e.target.value })
                  }
                  className={`${inputClasses} resize-none`}
                  placeholder="Escribe tu mensaje..."
                />
              </label>
            </div>

            <div className="mt-6 flex flex-wrap gap-3">
              <button
                type="submit"
                className="inline-flex items-center justify-center rounded-xl bg-[#3f5232] px-5 py-2.5 text-sm font-medium text-white shadow-sm transition hover:-translate-y-0.5 hover:bg-[#2f3b25] hover:shadow"
              >
                Enviar
              </button>

              <a
                href="https://wa.me/573142035583?text=Hola%20Yerika,%20estoy%20interesado%20en%20tus%20servicios%20Full%20Stack."
                target="_blank"
                rel="noreferrer"
                className="inline-flex items-center justify-center rounded-xl border border-[#3f5232]/25 bg-white px-5 py-2.5 text-sm font-medium text-slate-800 shadow-sm transition hover:-translate-y-0.5 hover:border-[#3f5232]/45 hover:bg-[#f4f6f1] hover:shadow"
              >
                WhatsApp
              </a>

              <a
                href="mailto:marleyrozo@gmail.com"
                className="inline-flex items-center justify-center rounded-xl border border-slate-200 bg-white px-5 py-2.5 text-sm font-medium text-slate-700 shadow-sm transition hover:-translate-y-0.5 hover:shadow"
              >
                Abrir correo
              </a>
            </div>

            <div className="mt-6 h-px w-full bg-gradient-to-r from-[#3f5232]/20 via-slate-200/70 to-transparent" />

            <div className="mt-4 text-sm text-slate-600">
              <span className="font-medium text-slate-800">Ubicación:</span>{" "}
              Cúcuta, N. de Santander — Colombia
            </div>
          </form>

          {/* REFERENCIAS */}
          <div className="rounded-2xl border border-[#3f5232]/15 bg-white/70 backdrop-blur p-6 shadow-sm">
            <div className="flex items-center justify-between gap-3">
              <h3 className="text-lg font-semibold text-slate-900">
                Referencias
              </h3>
              <span className="text-xs font-medium text-[#3f5232] bg-[#f4f6f1] border border-[#3f5232]/15 px-3 py-1 rounded-full">
                Contacto profesional
              </span>
            </div>

            <ul className="mt-5 space-y-4 text-sm">
              {references.map((ref, i) => (
                <li
                  key={i}
                  className="rounded-xl border border-slate-200/70 bg-white/60 p-4"
                >
                  <div className="font-semibold text-slate-900">{ref.name}</div>
                  <div className="mt-1 text-slate-600">
                    {ref.role} — {ref.company}
                  </div>
                  <a
                    href={`mailto:${ref.email}`}
                    className="mt-2 inline-flex items-center gap-2 font-medium text-[#3f5232] hover:underline"
                  >
                    {ref.email}
                    <span aria-hidden="true">→</span>
                  </a>
                </li>
              ))}
            </ul>

            <div className="mt-6 h-px w-full bg-gradient-to-r from-[#3f5232]/20 via-slate-200/70 to-transparent" />

            <p className="mt-4 text-sm text-slate-600">
              También puedes escribirme directamente a{" "}
              <a
                className="font-medium text-[#3f5232] hover:underline"
                href="mailto:marleyrozo@gmail.com"
              >
                marleyrozo@gmail.com
              </a>
              .
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Contact;
